import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { style: {"font-weight":"bold","margin":"0"} }

import StocktakingManual from '@/components/stocktaking/StocktakingManual.vue'
import { IonText, } from '@ionic/vue';
import { TPlace } from '@/const/types/place';


export default /*#__PURE__*/_defineComponent({
  __name: 'StocktakingPlaceSelectionIndicator',
  props: {
    selectedPlace: null
  },
  setup(__props: any) {

const props = __props as {
    selectedPlace: TPlace;
};




return (_ctx: any,_cache: any) => {
  return (!props.selectedPlace)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonText), null, {
          default: _withCtx(() => [
            _createTextVNode("Place is not selected. Start action by scaning place.")
          ]),
          _: 1
        }),
        _hoisted_2,
        _createVNode(StocktakingManual)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createVNode(_unref(IonText), null, {
          default: _withCtx(() => [
            _createTextVNode(" Selected place (scan to change):"),
            _hoisted_4
          ]),
          _: 1
        }),
        _createElementVNode("p", _hoisted_5, _toDisplayString(props.selectedPlace.name), 1)
      ]))
}
}

})